module.exports = __webpack_public_path__ + "img/svb.26780c4c.png";